import { ElementRef, OnDestroy } from '@angular/core';
import { ErgFeedbackService } from './erg-feedback.service';
var ErgAppFeedbackComponent = /** @class */ (function () {
    function ErgAppFeedbackComponent(feedbackService, elementRef) {
        this.feedbackService = feedbackService;
        this.elementRef = elementRef;
        this.isAdmin = false;
        this.userId = '';
        this.isOpen = false;
        this.view = 'form';
        this.isSubmitting = false;
        this.submitAttempted = false;
        this.errorMessage = '';
        this.experienceRating = 0;
        this.feedbackType = null;
        this.feedbackDetails = '';
        this.ratingOptions = [
            { value: 1, label: 'Very poor' },
            { value: 2, label: 'Poor' },
            { value: 3, label: 'Okay' },
            { value: 4, label: 'Good' },
            { value: 5, label: 'Excellent' }
        ];
        this.feedbackTypeOptions = [
            { value: 'Issue', label: 'Issue', icon: 'fa-exclamation-circle' },
            { value: 'Idea', label: 'Idea', icon: 'fa-lightbulb-o' },
            { value: 'Other', label: 'Other', icon: 'fa-comment-o' }
        ];
        this.isLoadingResponses = false;
        this.responsesError = '';
        this.responses = [];
        this.previouslyFocused = null;
        this.returnFocusId = '';
        this.originalBodyOverflow = '';
        this.pageScrollLocked = false;
    }
    ErgAppFeedbackComponent.prototype.ngOnDestroy = function () {
        this.unlockPageScroll();
    };
    ErgAppFeedbackComponent.prototype.onEscape = function () {
        if (this.isOpen) {
            this.requestClose();
        }
    };
    ErgAppFeedbackComponent.prototype.onOverlayClick = function (event) {
        if (event.target === event.currentTarget) {
            this.requestClose();
        }
    };
    ErgAppFeedbackComponent.prototype.open = function () {
        this.resetForm();
        this.view = 'form';
        this.openDialog();
    };
    ErgAppFeedbackComponent.prototype.openResponses = function () {
        if (!this.isAdmin) {
            return;
        }
        this.view = 'responses';
        this.openDialog();
        this.loadResponses();
    };
    ErgAppFeedbackComponent.prototype.loadResponses = function () {
        var _this = this;
        if (!this.isAdmin) {
            return;
        }
        this.isLoadingResponses = true;
        this.responsesError = '';
        this.responses = [];
        this.feedbackService.getFeedback().subscribe(function (data) {
            _this.responses = data || [];
            _this.isLoadingResponses = false;
        }, function (error) {
            _this.isLoadingResponses = false;
            _this.responsesError = 'Could not load feedback responses. Please try again.';
            console.error('Error loading app feedback:', error);
        });
    };
    ErgAppFeedbackComponent.prototype.requestClose = function () {
        if (!this.isOpen || this.isSubmitting) {
            return;
        }
        if (this.view === 'discard') {
            this.keepEditing();
            return;
        }
        if (this.view === 'form' && this.isDirty) {
            var activeElement = document.activeElement;
            this.returnFocusId = activeElement && activeElement.id ? activeElement.id : '';
            this.view = 'discard';
            this.focusAfterRender('.erg-fb-discard-keep');
            return;
        }
        this.closeDialog();
    };
    ErgAppFeedbackComponent.prototype.keepEditing = function () {
        this.view = 'form';
        this.focusAfterRender(this.returnFocusId ? '#' + this.returnFocusId : '#ergFbDetails');
    };
    ErgAppFeedbackComponent.prototype.discardFeedback = function () {
        this.resetForm();
        this.closeDialog();
    };
    ErgAppFeedbackComponent.prototype.startNewFeedback = function () {
        this.resetForm();
        this.view = 'form';
        this.focusAfterRender('#ergFbRating1');
    };
    Object.defineProperty(ErgAppFeedbackComponent.prototype, "isDirty", {
        get: function () {
            return this.experienceRating > 0 || this.feedbackType !== null || this.feedbackDetails.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErgAppFeedbackComponent.prototype, "ratingIsValid", {
        get: function () {
            return Number.isInteger(this.experienceRating) && this.experienceRating >= 1 && this.experienceRating <= 5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErgAppFeedbackComponent.prototype, "feedbackTypeIsValid", {
        get: function () {
            var _this = this;
            return this.feedbackTypeOptions.some(function (option) { return option.value === _this.feedbackType; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErgAppFeedbackComponent.prototype, "detailsAreValid", {
        get: function () {
            var detailLength = this.feedbackDetails.trim().length;
            return detailLength >= 1 && detailLength <= 500;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErgAppFeedbackComponent.prototype, "formIsValid", {
        get: function () {
            return this.ratingIsValid && this.feedbackTypeIsValid && this.detailsAreValid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErgAppFeedbackComponent.prototype, "detailsPlaceholder", {
        get: function () {
            switch (this.feedbackType) {
                case 'Issue':
                    return 'What happened, and what were you trying to do?';
                case 'Idea':
                    return 'What would make ERG Connect work better for you?';
                default:
                    return 'Tell us what you would like us to know.';
            }
        },
        enumerable: true,
        configurable: true
    });
    ErgAppFeedbackComponent.prototype.submit = function () {
        var _this = this;
        if (this.isSubmitting) {
            return;
        }
        this.submitAttempted = true;
        if (!this.formIsValid) {
            this.focusFirstInvalidControl();
            return;
        }
        var userId = this.userId.trim();
        if (!userId) {
            this.errorMessage = 'We could not identify your account. Please refresh the page and try again.';
            this.focusAfterRender('#ergFbFormError');
            return;
        }
        this.isSubmitting = true;
        this.errorMessage = '';
        var payload = {
            experienceRating: this.experienceRating,
            feedbackType: this.feedbackType,
            feedbackDetails: this.feedbackDetails.trim(),
            userId: userId
        };
        this.feedbackService.saveFeedback(payload).subscribe(function () {
            _this.isSubmitting = false;
            _this.submitAttempted = false;
            _this.view = 'success';
            _this.focusAfterRender('#ergFbSuccessClose');
        }, function (error) {
            _this.isSubmitting = false;
            _this.errorMessage = 'Something went wrong while saving your feedback. Please try again.';
            _this.focusAfterRender('#ergFbFormError');
            console.error('Error saving app feedback:', error);
        });
    };
    ErgAppFeedbackComponent.prototype.ratingLabel = function (value) {
        var option = this.ratingOptions.find(function (rating) { return rating.value === value; });
        return option ? option.label : 'Not rated';
    };
    ErgAppFeedbackComponent.prototype.trackResponse = function (_index, response) {
        return response.feedbackId;
    };
    ErgAppFeedbackComponent.prototype.openDialog = function () {
        this.previouslyFocused = document.activeElement;
        this.isOpen = true;
        this.lockPageScroll();
    };
    ErgAppFeedbackComponent.prototype.closeDialog = function () {
        this.isOpen = false;
        this.unlockPageScroll();
        if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
            this.previouslyFocused.focus();
        }
    };
    ErgAppFeedbackComponent.prototype.focusFirstInvalidControl = function () {
        if (!this.ratingIsValid) {
            this.focusAfterRender('#ergFbRating1');
        }
        else if (!this.feedbackTypeIsValid) {
            this.focusAfterRender('#ergFbTypeIssue');
        }
        else {
            this.focusAfterRender('#ergFbDetails');
        }
    };
    ErgAppFeedbackComponent.prototype.focusAfterRender = function (selector) {
        var _this = this;
        setTimeout(function () {
            var element = _this.elementRef.nativeElement.querySelector(selector);
            if (element) {
                element.focus();
            }
        });
    };
    ErgAppFeedbackComponent.prototype.lockPageScroll = function () {
        if (this.pageScrollLocked) {
            return;
        }
        this.originalBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.pageScrollLocked = true;
    };
    ErgAppFeedbackComponent.prototype.unlockPageScroll = function () {
        if (!this.pageScrollLocked) {
            return;
        }
        document.body.style.overflow = this.originalBodyOverflow;
        this.pageScrollLocked = false;
    };
    ErgAppFeedbackComponent.prototype.resetForm = function () {
        this.isSubmitting = false;
        this.submitAttempted = false;
        this.errorMessage = '';
        this.experienceRating = 0;
        this.feedbackType = null;
        this.feedbackDetails = '';
        this.returnFocusId = '';
    };
    return ErgAppFeedbackComponent;
}());
export { ErgAppFeedbackComponent };
